export default {
  graphql: 'https://rickandmortyapi.com/graphql',
};
